<template>
  <div class="article-share-icons">
    <AtomsTextLink :href="`https://www.facebook.com/sharer/sharer.php?u=${fullUrl}`" target="_blank" @click="analyticsShare('Facebook')">
      <AtomsImagesImage src="/img/icon-fb.svg" alt="Facebook" />
      {{ $t('Sdílet článek s přáteli na facebooku') }}
    </AtomsTextLink>
    <AtomsTextLink :href="`mailto:?subject=${encodeURIComponent(i18n.t('Super článek na Rigad.cz'))}&body=${encodeURIComponent(i18n.t('Ahoj, na rigad.cz je super článek, který mě zaujal - {0}. Mrkni na něj. Myslím, že se Ti také bude líbit {1}.', [props.articleHeader, fullUrl]))}`" target="_blank" @click="analyticsShare('E-mail')">
      <AtomsImagesImage src="/img/icon-email.svg" alt="E-mail" />
      {{ $t('Poslat článek někomu e-mailem') }}
    </AtomsTextLink>
    <AtomsTextLink :href="cache.getPageUrl(24352)" target="_blank" @click="analyticsShare('RSS')">
      <AtomsImagesImage src="/img/icon-rss.svg" alt="RSS" />
      {{ $t('Přihlásit odběr článků do RSS čtečky') }}
    </AtomsTextLink>
    <button @click="copyToClipboard">
      <AtomsImagesImage src="/img/icon-clipboard.svg" alt="Schránka" />
      {{ $t('Zkopírovat odkaz do schránky') }}
    </button>
  </div>
</template>
<script setup>

const props = defineProps({
  articleHeader: String,
  articleAnalyticsData: Object
});

const message = useMessage();
const cache = useCache();
const i18n = useI18n();
const shopZone = useShopZone();

const fullUrl = `https://${shopZone.value.domain}${useRoute().fullPath}`;

const analyticsShare = (method) => {

  let eventData = {
    share_method: method,
    share_content_type: 'Magazín'
  };

  eventData = Object.assign(eventData, props.articleAnalyticsData);

  useBaseAnalytics().pushEvent('share', eventData);
}

const copyToClipboard = () => {
  navigator.clipboard.writeText(fullUrl)
    .then(() => {
      message.show(i18n.t('Odkaz byl zkopírován do schránky'), null, false);
    })
    .catch(err => {
      message.show(i18n.t('Odkaz nebylo možné zkopírovat do schránky'), null, true);
    });

  analyticsShare('Zkopírováno do schránky');
};

</script>
<style lang="postcss">
.article-share-icons {
  @apply inline-flex flex-wrap items-start justify-center gap-8;

  &>* {
    @apply w-[calc(50%-2rem)] tracking-normal tablet:max-w-[120px];

    & img {
      @apply w-12 mx-auto mb-2;
    }
  }

  button:hover {
    @apply underline;
  }
}
</style>